export const DEVOPS_PLATFORMS = [
  { value: 'AzureDevOps', label: 'Azure DevOps' },
  { value: 'Jira', label: 'Jira' },
  { value: 'GitHubIssues', label: 'GitHub Issues' },
  { value: 'GitLab', label: 'GitLab' },
  { value: 'Other', label: 'Outra' },
] as const;

export type DevOpsPlatformValue = (typeof DEVOPS_PLATFORMS)[number]['value'];

export function devOpsPlatformLabel(value: string): string {
  return DEVOPS_PLATFORMS.find((p) => p.value === value)?.label ?? value;
}
